module.exports = __webpack_public_path__ + "static/media/2.f28381a1.svg";